import { useEffect, useState } from 'react';
import { ResursTreeApi } from '../services/modules/tree';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../services/types/store-types';

const KeyboardAction = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();

  const lastSelect = useSelector(
    (state: RootState) => state.tree.selectedNodes
  );

  useEffect(() => {
    const keyDownHandler = async (event: any) => {
      if (event.code === 'KeyZ' && (event.ctrlKey || event.metaKey)) {
        const response = await ResursTreeApi.undoAction();
        if (response) {
          setIsUndoActionGetTree(true);
        }
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler); // Удаляем тот же обработчик, который был зарегистрирован
    };
  }, []);
  const [isUndoActionGetTree, setIsUndoActionGetTree] = useState(false);
  useEffect(() => {
    if (isUndoActionGetTree && lastSelect && lastSelect.tree) {
      setIsUndoActionGetTree(false);
      dispatch(
        ResursTreeApi.getPropertysRedux({
          objects: lastSelect.objectIds.map((item: any) => Number(item)),
          tree: lastSelect.tree,
        })
      );
    }
  }, [lastSelect, isUndoActionGetTree]);
  return <>{children}</>;
};

export default KeyboardAction;
